/**
 * Pure presentation helpers: status/verdict badges, KPI tiles, small formatters,
 * and view mapping. Signal- and loader-free so they form a leaf module the
 * screens import (part of the app.tsx split, HS2-ZB7GJN). JSX renders to SafeHtml
 * via the kerf runtime.
 */

export function num(v: string | null | undefined): number | null {
  if (v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Confidence → the shading level of a matched matrix cell (its `data-match`). */
export function cellMatch(confidence: number | null, status: string): 'hi' | 'mid' | 'lo' | 'ok' {
  if (status === 'suggested') {
    if (confidence !== null && confidence >= 0.9) return 'hi';
    if (confidence !== null && confidence >= 0.7) return 'mid';
    return 'lo';
  }
  return 'ok';
}

/** The primary view a screen belongs to (drives the toolbar segmented control and
 *  the contextual sidebar list). Vendors and the knowledge base are organization
 *  settings surfaces, so they belong to Settings (HS2-CJM2YK). */
export function primaryView(v: string): 'demands' | 'chat' | 'stats' | 'settings' | '' {
  if (v === 'demands' || v === 'workspace' || v === 'intake') return 'demands';
  if (v === 'conversations') return 'chat';
  if (v === 'savings') return 'stats';
  if (v === 'settings' || v === 'vendors' || v === 'library') return 'settings';
  return '';
}
